import jQuery from "jquery";

import { isFormat } from "./format";
import { setSliderValue, refreshSlider } from "./sliders";

const $ = jQuery;

export function minifyAsteriskSection() {
  if (isFormat("legacy_fda/adult/vertical")) {
    if ($("#asterisksectionminitoggle").is(":checked")) {
      $(".asterisksection").fadeOut("fast", () => {
        $("#asterisksection-replace").fadeIn("slow");
      });
    } else {
      $("#asterisksection-replace").fadeOut("fast", () => {
        $(".asterisksection").fadeIn("slow");
      });
    }
  } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
    if ($("#asterisksectionminitoggle").is(":checked")) {
      $(".asterisksectionaggregate").fadeOut("fast", () => {
        $("#asterisksection-replace-aggregate").fadeIn("slow");
      });
    } else {
      $("#asterisksection-replace-aggregate").fadeOut("fast", () => {
        $(".asterisksectionaggregate").fadeIn("slow");
      });
    }
  } else if (isFormat("legacy_fda/adult/tabular")) {
    if ($("#asterisksectionminitoggle").is(":checked")) {
      $("#tabular_asterisk_col").fadeOut("fast", () => {
        $("#asterisksectiontabular-replace").fadeIn("slow");
        $("#tabularheading").css("padding-bottom", "0px");
        $("#tabularcalories").css("margin-top", "0px");
        $(".longform").hide();
        $(".abbreviated").show();
        $("#tabularslider").slider("option", "min", 120);
        setSliderValue("#tabularslider", 130);
      });
    } else {
      $("#asterisksectiontabular-replace").fadeOut("fast", () => {
        $("#tabular_asterisk_col").fadeIn("slow");
        $("#tabularheading").css("padding-bottom", "12px");
        $("#tabularcalories").css("margin-top", "7px");
        $(".longform").show();
        $(".abbreviated").hide();
        $("#tabularslider").slider("option", "min", 160);
        setSliderValue("#tabularslider", 175);
      });
    }
  } else if (isFormat("fda/adult/tabular")) {
    if (
      $("#asterisksectionminitoggle").is(":checked") ||
      $("#newsimplifiedformattoggle").is(":checked")
    ) {
      const allPromise = Promise.all([
        $("#new_tabular_asterisk_col").fadeOut("fast").promise(),
        $("#new_tabular_dual_asterisk_row").fadeOut("fast").promise(),
        $(".dailyvalue-asterisk").hide().promise(),
        $(".longform").hide().promise(),
        $(".abbreviated").show().promise(),
      ]);

      if ($("#new_tabular_dual_nutrient_cols").length <= 0) {
        allPromise.then(() => {
          refreshSlider("#newtabularslider");
        });
      }
    } else {
      $("#new_tabular_asterisk_col").fadeIn("slow");
      $("#new_tabular_dual_asterisk_row").fadeIn("fast");
      $(".dailyvalue-asterisk").show();
      $(".longform").show();
      $(".abbreviated").hide();
      if ($("#new_tabular_dual_nutrient_cols").length > 0) {
        // do nothing
      } else {
        refreshSlider("#newtabularslider");
      }
    }
  }
}
